// src/config/dossierPermissions.js
// §8ter / DPA §4.2 — Permissions GRANULAIRES par catégorie sur un dossier client.
// « Aucune vue globale n'est accordée par défaut. » Le client relié contrôle et
// peut révoquer. Certaines catégories sont réellement appliquées côté base (ex.
// `locations` → collection_permissions.can_view_location) ; les autres sont
// déclaratives en V1 et à brancher table par table (marqué enforcedServerSide).

export const PERMISSION_CATEGORIES = [
  { key: "artworks", enforcedServerSide: true },        // œuvres et documentation (can_view)
  { key: "valuations", enforcedServerSide: false },     // valorisations
  { key: "locations", enforcedServerSide: true },       // localisations (can_view_location)
  { key: "confidential_docs", enforcedServerSide: false },
  { key: "members_heirs", enforcedServerSide: false },
  { key: "estate_info", enforcedServerSide: false },
  { key: "export_share", enforcedServerSide: false },
];

export const PERMISSION_KEYS = PERMISSION_CATEGORIES.map((c) => c.key);

// Défaut : minimal. L'Advisor voit les œuvres qu'il gère ; tout le reste OFF
// (aucune vue globale par défaut, notamment localisations et successoral).
export const DEFAULT_GRANTS = {
  artworks: true,
  valuations: false,
  locations: false,
  confidential_docs: false,
  members_heirs: false,
  estate_info: false,
  export_share: false,
};

export function mergeGrants(stored) {
  return { ...DEFAULT_GRANTS, ...(stored || {}) };
}

export const PERMISSION_LABELS = {
  fr: {
    artworks: "Œuvres et documentation",
    valuations: "Valorisations",
    locations: "Localisations",
    confidential_docs: "Documents confidentiels",
    members_heirs: "Membres et héritiers",
    estate_info: "Informations successorales",
    export_share: "Export et partage externe",
  },
  en: {
    artworks: "Artworks and documentation",
    valuations: "Valuations",
    locations: "Locations",
    confidential_docs: "Confidential documents",
    members_heirs: "Members and heirs",
    estate_info: "Estate information",
    export_share: "Export and external sharing",
  },
  de: {
    artworks: "Werke und Dokumentation",
    valuations: "Bewertungen",
    locations: "Standorte",
    confidential_docs: "Vertrauliche Dokumente",
    members_heirs: "Mitglieder und Erben",
    estate_info: "Nachlassinformationen",
    export_share: "Export und externe Freigabe",
  },
};

export function permissionLabel(key, lang) {
  const l = String(lang || "fr").slice(0, 2).toLowerCase();
  return (PERMISSION_LABELS[l] || PERMISSION_LABELS.fr)[key] || key;
}
